<template>
<div id="form-import">
  <div :class="['pt-3 pb-4', 'form-import-' + (darkMode ? 'dark' : 'bright')]">
    <h1 v-if="showHeading" class="white">Import</h1>
    <!--<div class="lighter mb-1">{{ $t('Please select a format for your import.') }}</div>-->
    <!-- Language Export -->
    <div
        :class="['settings-button mr-1 d-inline-block with-distinct-border',
                showImportPrompt === importPossibilities.LANGUAGE ? 'orange no-hover' : 'switched-colors']"
        @click="showImportPrompt = importPossibilities.LANGUAGE;"
    >
      <icon class="mr-2" type="globe" />
      {{ $t("vform.language") }}
    </div>
  </div>
  <div :class="['col-12 border-radius form-import-details', darkMode ? 'darker' : 'brighter',!showImportPrompt ? 'collapsed' : '']">

  <div v-if="showImportPrompt === importPossibilities.LANGUAGE">
    <language-import
      :organization-id="organizationId"
      :project-id="projectId"
      :form-id="formId"
      :slides="slides"
      :config="config"
    />
  </div>
  </div>
</div>
</template>

<script>
import LanguageImport from "@/components/vFormImportExport/LanguageImport.vue";
import Icon from "@/components/Icon.vue";
export default {
  name: "vFormImport",
  components: {
    Icon,
    LanguageImport
  },
  props: {
    organizationId: {type: String, required: true},
    projectId: {type: String, required: true},
    formId: {type: String, required: true},
    slides: {type: Array, required: true},
    config: {type: Object, required: true},
    darkMode: {type: Boolean, default: true},
    showHeading: {type: Boolean, default: true},
  },
  data() {
    return {
      showImportPrompt: 'Language',
      importPossibilities: Object.freeze({
        LANGUAGE: 'Language',
      }),
    }
  },
}
</script>

<style lang="scss">
$left-side: 160px;
.newStyle #form-import {
  h1.white {
    color: rgba(255,255,255,0.8);
  }
  h2 {
    font-family: 'Inter bold', sans-serif;
    font-weight: bold;
    text-transform: none;
    color: rgba(255,255,255,0.7);
    font-size: 1.2rem;
  }
}
.left-side {
  width: $left-side;
}
.generate-legend-box {
  border-top: 1px solid rgba(255,255,255,0.4);
  padding-top: 15px;
  margin-top: 15px;
  // margin-left: $left-side - 10px;
}
</style>

<style lang="scss" scoped>
.form-import-details {
  transition: all 300ms ease;
  max-height: 1000px;
  padding: 20px;
  background-color: rgba(0,0,0,0.5);
  min-height: 230px;
  &.collapsed {
    height: 0;
    padding: 0;
    overflow: hidden;
    min-height: 0;
  }
  &.brighter {
    background-color: #f5f5f5;
    h2 {
      color: #333 !important;
    }
  }
}
.form-import-bright {
  background-color: #f5f5f5;
  h1 {
    color: #333 !important;
  }
}

</style>
